import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPrivacyMdFileUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(locale: string): Promise<SATResult<ParentalConsentInfo, SATError>> {
    return this.appAccountSettingRepo.fetchPrivayMdFile(locale);
  }
}
